import React from 'react';
import { Field, reduxForm, getFormValues} from 'redux-form';
import { Button, Grid } from '@material-ui/core';
import firebase from '../config/firebase';
import { connect } from "react-redux";

import {
  renderTextField,
  renderPasswordField,
  validator
} from './InputFields';

const validateEmail = e => /^([a-zA-Z0-9_.-])+@giantkiller.com+$/.test(e);

// user location in firebase database
const usersDB = firebase.database().ref('users');
// user email
let email = '';
// user password
let password = '';

const mapStateToProps = state => {
  const formState = getFormValues('loginForm')(state);
  if (formState !== undefined) {
    email = formState.email;
    password = formState.password;
  }
  return formState;
}

// called when user presses the Sign Up button
function handleSignUp() {
  // new administrator properties
  let admin = {
    master: false,
  };
  // if user's email matches the regex, give them admin rights
  if (validateEmail(email)) {
    admin.master = true;
  }
  firebase.auth().createUserWithEmailAndPassword(email, password)
    .then(function(user) {
      usersDB.child(user.uid)
      // set user's privileges and data
      .set({
          admin,
          email,
          id: user.uid,
        })
      // let user know signup was a success
      .then(alert('Successfully Signed Up with email '+email))})
      // if not, alert them as to why it was not
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // [START_EXCLUDE]
        if (errorCode === 'auth/weak-password') {
          alert('The password is too weak.');
        } else {
          alert(errorMessage);
        }
        console.log(error);
    })
}

let LoginForm = props => {
  const { handleSubmit } = props

  return (
    <form onSubmit={ handleSubmit }>
      {/* email entry field */}
      <Field
        name="email"
        component={renderTextField}
        validate={[validator.required, validator.email]}
        required
        label="Email"
        style={{width: 220}}/><br/>
      <div style={{margin: 10}}/>
      {/* password entry field */}
      <Field
        required
        name="password"
        component={renderPasswordField}
        validate={validator.required}
        label="Password"
        style={{width: 220}}/> <br/>
      <div style={{marginBottom: 20}}/>
      { props.children}
      {/* button container */}
      <Grid container
        direction={'row'}
        spacing={16}
        justify={'center'}
        alignItems={'center'}
      >
        {/* Login button */}
        <Grid style={{margin:5}}>
          <Button
            type="submit"
            variant="raised"
            color="primary"
            labelStyle={{color: '#ffffff'}}
          >
            Login
          </Button>
          <br />
        </Grid>
        {/* Signup button */}
        <Grid style={{margin:5}}>
          {/* <SignUpButton form={'loginform'}/> */}
          <Button
            onClick={() =>{handleSignUp()}}
            type=""
            variant="raised"
            color="primary"
            labelStyle={{color: '#ffffff'}}
          >
            Sign Up
          </Button>
          <br/>
        </Grid>
      </Grid>
    </form>
  )
}

LoginForm = reduxForm({
  form: 'loginForm'
})(LoginForm);

export default connect(mapStateToProps)(LoginForm);
